import {
  tile,
  icon as icon_cn,
  title as title_cn,
  description as description_cn,
  container,
  light,
} from "./contact-us-tiles.module.css"
import RichText from "../rich-text/renderer"
import { MikanSpan } from "../Mikan"
import { FastlyImage } from "@components/FastlyImage"

const ContactUsTile = ({ footer, content, media, header, className }) => {
  const type = className === "light" ? light : ""
  return (
    <div className={`${tile} ${type}`}>
      <FastlyImage src={media?.content.file.url} alt="" className={icon_cn} key={media?.contentful_id} />
      <h3 className={title_cn}>
        <MikanSpan text={header} />
      </h3>
      <div className={description_cn}>
        <RichText body={content} />
      </div>
      <RichText body={footer} />
    </div>
  )
}

const ContactUsTiles = ({ content }) => (
  <div className={container}>
    {content.section_content.map((content) => (
      <ContactUsTile {...content} key={content.title} />
    ))}
  </div>
)

export default ContactUsTiles
